// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed5f4a35","239":"d0a834e9","453":"71b34086","732":"3c6ae3e3"}[chunkId] + ".chunk.js";
};